import { render, staticRenderFns } from "./DodBorderSection.vue?vue&type=template&id=ef68c8c0&scoped=true&"
var script = {}
import style0 from "./DodBorderSection.vue?vue&type=style&index=0&id=ef68c8c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef68c8c0",
  null
  
)

export default component.exports